import api from '../..'

const removeProfileBulkAction = (userIds: number[]) => {
  return api.delete(`administration/multiple_profiles`, { data: { multiples: { userIds } } })
}

export default removeProfileBulkAction
